(() => {
  if (location.hash !== '#artwork-gallery') return;
  const script = document.currentScript;
  if (!script?.dataset.galleryUrl) return;
  const target = new URL(script.dataset.galleryUrl, location.origin);
  const current = new URL(location.href);
  for (const key of ['preview_theme_id', '_fd', 'pb']) {
    if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
  }
  if (current.searchParams.get('view') === 'shejtano-gallery') {
    current.hash = '';
    history.replaceState(null, '', current);
    return;
  }
  location.replace(target);
})();
